import BaseAPI from "../api";

const path: string = "/thesis-book";

export type listType = {
  keyword?: number;
  limit?: number;
  page?: number;
};

export class ThesisBookApi extends BaseAPI {
  static list(query: listType): Promise<any> {
    return this.api.get(`${path}`, {
      params: { ...query },
    });
  }
  static post(body: any): Promise<any> {
    return this.api.post(`${path}`, body, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
  static patch(body: any, id: any): Promise<any> {
    return this.api.patch(`${path}/${id}`, body, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
  static findById(id: any): Promise<any> {
    return this.api.get(`${path}/${id}`);
  }
  static delete(id: any): Promise<any> {
    return this.api.delete(`${path}/${id}`);
  }
  static downloadfile(id: any): Promise<any> {
    return this.api.get(`${path}/${id}/downloadfile`, {
      responseType: "arraybuffer",
    });
  }
}
